import React, {useState} from "react";
import {useForm} from "react-hook-form";
import ValueFields from "./ValueFields";

export default function () {
  const {register, handleSubmit, reset, control, watch} = useForm();
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  const valueFields = <ValueFields {...{register, errors, control, watch, data}} />;

  return {
    setErrors,
    valueFields,
    handleSubmit,
    setData,
    reset,
  }
}